export default "__VITE_ASSET__29c829a6__"